import { Component, Input, OnInit } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { Event, NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { RootScopeDeclare } from '../../core/rootscope-declare';
import { RootScopeService } from '../../core/shared-service/root-scope.service';
import { ToastMessageService } from '../../core/shared-service/toast-message.service';
@Component({
  selector: 'app-pre-login-base',
  templateUrl: './pre-login-base.component.html',
  styleUrls: ['./pre-login-base.component.css'],
})
export class PreLoginBaseComponent implements OnInit {
  public showHeader = false;
  rootScopeData: RootScopeDeclare;
  toastMessage: string | SafeHtml | null | undefined;
  showToast: boolean;
  currentRoute: string;

  @Input() isAuthSuccess: boolean;
  private sub = new Subscription();
  constructor(
    private rootScopeService: RootScopeService,
    private toastMessageService: ToastMessageService,
    private router: Router
  ) {
    this.getRootScopeData();
    this.currentRoute = this.router.url;
    const routeSub = this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.currentRoute = this.router.url;
      }
    });

    this.sub.add(routeSub);

    // this.showToast = false;
    const toastMessageSub = toastMessageService.changeEmitted$.subscribe((text) => {
      this.enableToast(text);
    });
    this.sub.add(toastMessageSub);
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe((rootScopeData) => (this.rootScopeData = rootScopeData));
  }

  ngOnInit() {
    setTimeout(() => {
      this.showHeader = true;
    }, 3000);
  }

  closeToast(): void {
    this.showToast = false;
  }

  enableToast(msg: string): void {
    this.showToast = true;
    this.toastMessage = msg;
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
